<template>
  <div class="merchandise-wrapper">
    <h2 class="merchandise-title">
      Everything You Need to Merchandize
      <br />
      Smarter
    </h2>
    <p class="merchandise-subtitle">
      Our suite of tools helps you showcase your inventory effectively and drive more
      <br />
      engagement.
    </p>

    <div class="tools-grid">
      <Card v-for="(tool, index) in tools" :key="index" class="tool-card">
        <template #title>
          <div class="tool-icon" v-html="tool.icon"></div>
          <h3 class="tool-title">{{ tool.title }}</h3>
        </template>
        <template #content>
          <p class="tool-description">{{ tool.description }}</p>
        </template>
      </Card>
    </div>
  </div>
</template>

<script setup>
import Card from 'primevue/card'
import 'primevue/resources/themes/lara-light-blue/theme.css'
import 'primevue/resources/primevue.min.css'
import 'primeicons/primeicons.css'

const tools = [
  {
    title: 'Scan2Sell',
    icon: `
      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" stroke="#2a68ed" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
        <rect width="5" height="5" x="3" y="3" rx="1"></rect>
        <rect width="5" height="5" x="16" y="3" rx="1"></rect>
        <rect width="5" height="5" x="3" y="16" rx="1"></rect>
        <path d="M21 16h-3a2 2 0 0 0-2 2v3"></path>
        <path d="M21 21v.01"></path>
        <path d="M12 7v3a2 2 0 0 1-2 2H7"></path>
        <path d="M3 12h.01"></path>
        <path d="M12 3h.01"></path>
        <path d="M12 16v.01"></path>
        <path d="M16 12h1"></path>
        <path d="M21 12v.01"></path>
        <path d="M12 21v-1"></path>
      </svg>
    `,
    description:
      'Print-ready QR codes for each vehicle in your inventory. Let on-lot shoppers instantly scan for live pricing, promotions, and vehicle details that match your website in real time.',
  },
  {
    title: 'Dynamic Vehicle Listings',
    icon: `
      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" stroke="#2a68ed" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
        <path d="M3 3v18h18"></path>
        <path d="M18 17V9"></path>
        <path d="M13 17V5"></path>
        <path d="M8 17v-3"></path>
      </svg>
    `,
    description:
      "Generate dynamic banners tailored to your inventory—styled like Google Vehicle Listing Ads but exclusive to your dealership's vehicles.",
  },
  {
    title: 'AI-Powered Vehicle Descriptions',
    icon: `
      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" stroke="#2a68ed" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
        <path d="M17 3a2.85 2.83 0 1 1 4 4L7.5 20.5 2 22l1.5-5.5Z"></path>
        <path d="m15 5 4 4"></path>
      </svg>
    `,
    description:
      'Create compelling, SEO-friendly vehicle descriptions using generative AI. Pulls directly from your inventory data to spotlight key selling points and increase shopper engagement.',
  },
  {
    title: 'Google Vehicle Listing Exporter',
    icon: `
      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" stroke="#2a68ed" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
        <circle cx="18" cy="5" r="3"></circle>
        <circle cx="6" cy="12" r="3"></circle>
        <circle cx="18" cy="19" r="3"></circle>
        <line x1="8.59" x2="15.42" y1="13.51" y2="17.49"></line>
        <line x1="15.41" x2="8.59" y1="6.51" y2="10.49"></line>
      </svg>
    `,
    description:
      "Easily sync your inventory with Google Merchant Center. Our tool handles Google's requirements so your listings appear accurately and efficiently in Google search results.",
  },
]
</script>

<style scoped>
.merchandise-wrapper {
  padding: 30px;
  text-align: center;
  max-width: 1440px;
  margin: auto;
}

.merchandise-title {
  font-size: 36px;
  font-weight: bold;
  margin-bottom: 10px;
  color: #0f1729;
  line-height: 40px;
  letter-spacing: -1px;
}

.merchandise-subtitle {
  color: #64748b;
  font-size: 18px;
  margin-bottom: 40px;
}

.tools-grid {
  display: grid;
  grid-template-columns: 1fr;
  gap: 20px;
}

@media (min-width: 768px) {
  .tools-grid {
    grid-template-columns: repeat(2, 1fr);
  }
}

@media (min-width: 1024px) {
  .tools-grid {
    grid-template-columns: repeat(4, 1fr);
  }
}

.tool-card {
  /* border: 1px solid #e0e0e0; */
  box-shadow: none;
  border-radius: 8px;
  padding: 20px;
  height: 100%;
}

.tool-icon {
  font-size: 24px;
  color: #2563eb;
  margin-bottom: 10px;
  width: 40px;
  height: 40px;

  /* text-align: start; */
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #f1f5f9;
  border-radius: 10px;
}

.tool-title {
  font-size: 20px;
  font-weight: 700;
  margin-bottom: 10px;
  text-align: start;
  color: #0f1729;
}

.tool-description {
  font-size: 16px;
  color: #64748b;
  line-height: 1.5;
  text-align: start;
}
@media (max-width: 768px) {
  .merchandise-title {
    font-size: 26px;
    line-height: 35px;
    text-align: start;
  }
  .merchandise-subtitle {
    font-size: 16px;
    text-align: start;
  }
}
</style>
